// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"48":"laboratory","353":"contact","417":"setting","431":"getmoney","857":"report","899":"payment","962":"home","964":"product"}[chunkId] + "." + {"48":"00cc97d5","353":"0f9f20bc","417":"88f93df0","431":"afa0094f","857":"1efb3f4f","899":"a8f9f611","962":"6e5fb891","964":"7e413014"}[chunkId] + ".js";
};